var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewFacturaGptGreenIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 94,
    viewBox: "0 0 95 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.8332 39.1668V35.2502C78.8332 31.6078 78.8332 29.7866 78.4329 28.2924C77.3464 24.2376 74.179 21.0703 70.1245 19.9839C68.6303 19.5835 66.809 19.5835 63.1665 19.5835",
    stroke: "#10A37F",
    strokeWidth: 9,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8332 54.8335V58.7502C78.8332 62.3927 78.8332 64.2139 78.4329 65.7081C77.3464 69.7627 74.179 72.9301 70.1245 74.0165C68.6303 74.4168 66.809 74.4168 63.1665 74.4168",
    stroke: "#10A37F",
    strokeWidth: 9,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6665 74.4168H35.7498C28.4287 74.4168 24.7681 74.4168 22.0415 72.8427C20.2553 71.8115 18.772 70.3282 17.7407 68.5418C16.1665 65.815 16.1665 62.1545 16.1665 54.8335",
    stroke: "#10A37F",
    strokeWidth: 9,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6665 19.5835H35.7498C28.4287 19.5835 24.7681 19.5835 22.0415 21.1577C20.2553 22.189 18.772 23.6723 17.7407 25.4585C16.1665 28.1851 16.1665 31.8457 16.1665 39.1668",
    stroke: "#10A37F",
    strokeWidth: 9,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6665 82.25V11.75",
    stroke: "#10A37F",
    strokeWidth: 11,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewFacturaGptGreenIcon);
export default __webpack_public_path__ + "static/media/newFacturaGPTGreenIcon.3722922ab479fd844d9b96b8b0e1bde0.svg";
export { ForwardRef as ReactComponent };